import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';

import { SltDataServiceRequestComponent } from './components/slt-data-service-request/slt-data-service-request.component';
import { SltDataServiceComponent } from './components/slt-data-service/slt-data-service.component';
import { SltAddDataServiceComponent } from './components/slt-add-data-service/slt-add-data-service.component';

@NgModule({
  declarations: [
    SltDataServiceRequestComponent,
    SltDataServiceComponent,
    SltAddDataServiceComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule
  ],
  exports: [
    SltDataServiceRequestComponent,
    SltDataServiceComponent,
    SltAddDataServiceComponent
  ]
})
export class SltApiDashboardModule { }

